import { Numeric9BoxMultipleOutlineIcon } from './Numeric9BoxMultipleOutlineIcon';

/**
 * author: Google
 * id A41F44A0-816E-497E-A08C-C9646FE161BE
 * name numeric-9-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric9BoxesOutlineIcon = Numeric9BoxMultipleOutlineIcon;
export default Numeric9BoxesOutlineIcon